<template>
  <!-- 积分排名 -->
  <div class="IA_pointsRanking">
    <van-nav-bar :title="'积分排名'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true">
      <template #right>
        <van-tag round
                 type="primary"
                 @click="checkDeptment">{{topdeptname}}</van-tag>
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="details">积分明细</div>
      <div class="points_list">
        <van-cell-group>
          <van-cell v-for="(item,idx) in perList"
                    :key="idx">
            <template #title>
              <div class="rank">{{item.rowid}}</div>
              <div class="name">{{item.empname}}</div>
              <div class="dept">{{item.deptname}}</div>
            </template>
            <template #default>
              <div class="cell_val zheng">{{item.total_credit}}</div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
    <!-- 选择部门树弹窗 -->
    <PopTree ref="popTreeNode"
             :module="1241"
             :multiseltree="false"
             @treeSelectValEvent="treeSelectValEvent"></PopTree>
  </div>
</template>

 <script>
import { getDeptCreditRanking } from '@api/integral.js'
import PopTree from '@components/PopTree/index.vue'
export default {
  components: {
    PopTree
  },
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    const topdeptname = this.$route.query.topdeptname
    const year = this.$route.query.year
    return {
      userInfo,
      topdeptname,
      year,
      perList: [],
      deptid: 0
    }
  },
  created () {
    this.topdeptname = this.$route.query.topdeptname
    this.year = this.$route.query.year
    this.deptid = 0
    this.getDeptCreditRankingData(0)
  },
  methods: {
    // 选择树回调
    treeSelectValEvent (data) {
      // console.log(data, 'treeSelectValEvent');
      this.topdeptname = data.deptname
      this.deptid = data.autoid
      this.getDeptCreditRankingData(this.deptid)
    },
    // 选择部门
    checkDeptment () {
      this.$refs.popTreeNode.module = 1241
      this.$refs.popTreeNode.treename = 'depttree'
      this.$refs.popTreeNode.fieldname = '_credit_ranking_query_'
      this.$refs.popTreeNode.editstate = 2
      this.$refs.popTreeNode.showEmpTreePop('部门')
    },
    // 查询积分排名
    getDeptCreditRankingData (deptid) {
      getDeptCreditRanking({
        yyyy: this.year,
        deptautoid: deptid,
        username: this.userInfo.username
      }).then(res => {
        this.perList = res.data
      })
    },
    // 返回
    onClickLeft () {
      this.$router.push({ path: '/pointsInquiry', query: { from: this.$route.query.from } })
    },
  }
}
</script>

<style lang="less" scoped>
.IA_pointsRanking {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    /deep/.van-nav-bar__right {
      width: 35%;
      justify-content: flex-end;
      .van-tag {
        max-height: 72px;
        line-height: 1.2;
        background-color: #f6f6f6;
        color: #333333;
        padding: 6px 20px;
        font-size: 28px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .van-nav-bar::after {
    border: none !important;
  }
  .content {
    // overflow: auto;
    margin-top: 1.21667rem;
    height: calc(100% - 92px);
    .details {
      height: 70px;
      padding: 10px 20px;
      font-size: 30px;
      color: #cccccc;
    }
    .points_list {
      height: calc(100% - 70px);
      overflow-y: auto;
      .van-cell-group {
        .van-cell {
          padding: 20px 20px;
          font-size: 30px;
          .van-cell__title {
            display: flex;
            align-items: center;
            flex: 3;
            .rank {
              height: 60px;
              line-height: 60px;
              width: 60px;
              font-size: 32px;
              color: #ffffff;
              border-radius: 50%;
              background: red;
              text-align: center;
              margin-right: 20px;
            }
            .name {
              font-size: 36px;
              color: #000000;
              flex: 2;
            }
            .dept {
              font-size: 24px;
              color: #8e8e8e;
              flex: 3;
            }
          }
          .van-cell__value {
            .cell_val {
              font-size: 36px;
            }
            .zheng {
              color: #07c160;
            }
          }
        }
      }
    }
  }
}
</style>